import { render } from "./QuerySelection.vue?vue&type=template&id=9d3c1fee"
import script from "./QuerySelection.vue?vue&type=script&lang=js"
export * from "./QuerySelection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__